export const dataProperties = {
  businessHours: 'businessHours',
};

// Indicate the Business Hour Style
export const Mode = {
  INLINE: 'inline',
  VERTICAL: 'vertical',
};
